export const cutText = function (input, width = 100) {
  return input.length > width ? input.substring(0, width - 3) + '...' : input;
};
